import { Component, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { BreakpointService, UrlUtils } from '@libs/index';
import { IMAGE_PLACEHOLDER } from '../../../models/consts/Other.const';
import { BaseComponent } from '@libs/index';
import { of } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { DialogService } from '@libs/index';
import {
  ImageFullsizeViewDialogComponent,
  ImageFullsizeViewDialogComponentData,
} from '../image-fullsize-view-dialog/image-fullsize-view-dialog.component';
import {
  GoogleMapsEmbedIframeDialogComponent,
  GoogleMapsEmbedIframeDialogComponentData,
} from '../google-maps-embed-iframe-dialog/google-maps-embed-iframe-dialog.component';

@Component({
  selector: 'app-salon-details-header',
  templateUrl: './salon-details-header.component.html',
  styleUrls: ['./salon-details-header.component.scss'],
})
export class SalonDetailsHeaderComponent extends BaseComponent {
  @Input() salonName: string;
  @Input() salonAddress: string;
  @Input() totalReviews: number;
  @Input() averageReview: number;
  @Input() hideShareButton: boolean;
  @Input() set googlePlaceId(placeId: string) {
    this.linkToGoogleMapReviewsPage =
      UrlUtils.createLinkToGoogleMapReviewsPage(placeId);
  }
  @Input() googleMapsEmbedLink: string;

  private _images: string[] = [IMAGE_PLACEHOLDER];
  @Input() set images(value: string[]) {
    if (value?.length) {
      this._images = value;
    } else {
      this._images = [IMAGE_PLACEHOLDER];
    }
  }
  get images(): string[] {
    return this._images;
  }

  public linkToGoogleMapReviewsPage: string;
  public isCopiedLink = false;

  constructor(
    public breakpointService: BreakpointService,
    private dialogService: DialogService,
    private clipboard: Clipboard
  ) {
    super();
  }

  public copyLinkToClipboard(): void {
    if (this.hideShareButton) {
      return;
    }

    this.clipboard.copy(window.location.href);
    this.isCopiedLink = true;

    of('')
      .pipe(takeUntil(this.componentDestroyed), delay(2000))
      .subscribe(() => (this.isCopiedLink = false));
  }

  public displayImageInFullsize(imageIndex: number): void {
    this.dialogService.openDialog(
      ImageFullsizeViewDialogComponent,
      this.dialogService.makeTransparent(
        this.dialogService.createFullsizeDialogConfig({
          images: this.images,
          selectedIndex: imageIndex,
        } as ImageFullsizeViewDialogComponentData)
      )
    );
  }

  public openGoogleMapEmbedIframeDialog(): void {
    this.dialogService.openDialog(
      GoogleMapsEmbedIframeDialogComponent,
      this.dialogService.createLargeDialogConfig({
        title: this.salonName,
        googleMapsEmbedLink: this.googleMapsEmbedLink,
      } as GoogleMapsEmbedIframeDialogComponentData)
    );
  }
}
